function togglePanel(panel) {
  const panelBody = panel.querySelector('.toggle-panel-body');
  panel.classList.toggle('open');
  panelBody.style.maxHeight = panel.classList.contains('open') ? panelBody.scrollHeight + 'px' : '0';
  const arrow = panel.querySelector('.arrow');
}

window.addEventListener("DOMContentLoaded", (event) => {
  const tocTitle = document.querySelector("#tocTitle");
  const tocContent = document.querySelector(".article");
  let tocTitles = tocContent.querySelectorAll("h2");
  
  tocTitle.innerHTML = tocTitles[0].innerHTML;
  
  tocTitles.forEach(function(heading, i) { // runs a function for all h2 elements inside your rich text element
    heading.setAttribute("id", "toc-" + i); // gives each h2 a unique id
    let str = heading.textContent; // adds section titles to slugs
    str = str.replace(/\s+/g, '-').replace(/[^\w\-]+/g, "").replace(/\d+/g, "").toLowerCase();
    heading.setAttribute("id", str); // gives each heading a unique id
    const item = document.createElement("a"); // creates an anchor element called "item" for each h2
    item.innerHTML = heading.textContent // gives each item the text of the corresponding heading
    item.setAttribute("class", "tocitem"); // gives each item the correct class
    item.setAttribute("href", "#" + str); // gives each item the correct anchor link
    document.querySelector("#toc").appendChild(item); // places each item inside the Table of Contents div
  });
  
  const header = document.querySelector('#shopify-section-header');
  const headerHeight = header.offsetHeight;
  
  let tocLinks = document.querySelectorAll(".tocitem");
  tocLinks.forEach((link) => {
    link.addEventListener('click', function(e) {
    	e.preventDefault();
        e.stopPropagation();
    	scrollIntoViewWithOffset(e.target.hash, 50);
        const panel = link.closest('.toggle-panel');
        const panelTitle = panel.querySelector('#tocTitle').innerHTML = link.innerHTML;
    
        for (let elem of tocLinks) {
        	elem.classList.remove('tocitem-active');
        }
        link.classList.add('tocitem-active');
    
        togglePanel(panel);
      });
  });
  
  const scrollIntoViewWithOffset = (selector, offset) => {
    if (window.screen.width <= 767) {
      offset = 430;
    }
  
    if (window.screen.width <= 480) {
      offset = 440;
    }
  
    window.scrollTo({
      behavior: 'smooth',
      top:document.querySelector(selector).getBoundingClientRect().top -
        document.body.getBoundingClientRect().top - offset,
    })
  }

  // position progress bar the header
  const elementToPosition = document.querySelector('.progress-container');
  const progress = document.querySelector('.progress-bar');
  const articleContent = document.querySelector('.article-content');
  
window.addEventListener('scroll', () => {
  const totalHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
  const sectionHeight = articleContent.offsetHeight;
  const sectionTop = articleContent.offsetTop;
  const sectionBottom = sectionTop + sectionHeight;
  const sectionProgress = (sectionHeight / totalHeight) * 100;
  const progressHeight = (window.pageYOffset === 0) ? 0 : ((window.pageYOffset - sectionTop) / (sectionHeight - document.documentElement.clientHeight)) * 100;

  if (progressHeight >= 100) {
    // User has reached the end of the section, fix progress bar at 100%
    progress.style.width = '100%';
  } else {
    // User is still inside the section, update progress bar width
    progress.style.width = `${progressHeight}%`;
  }
});

  // Add learn more to product section
  const addToCartBtn = document.querySelector(".add-to-cart");
  const learnMoreBtn = '<div class="learn-more rte"><a href="/products/hibernate">Learn more</a></div>';
  addToCartBtn.insertAdjacentHTML("afterend", learnMoreBtn);
});

var $j = jQuery.noConflict();

$j(document).ready(function() {
  $j('.referenceslistheader').click(function() {
    $j('#referenceslist-thelist').slideToggle('slow');
    $j('.expandclose').text(function(_, text) {
      return text === '+' ? '-' : '+';
    });
  });
});